import { saveAs } from 'file-saver';

import useError from '@/hooks/useError';
import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';

export const exportShipmentData = async ({
  shipmentId,
  makeRequest,
}: {
  shipmentId: string;
  makeRequest: any;
}): Promise<string> => {
  const { data, error } = await makeRequest({
    path: `/shipments/${shipmentId}/export`,
    responseType: 'blob',
  });

  if (error) {
    throw new Error('An error occurred while exporting the shipment data');
  }

  return data;
};

export const useExportShipmentHandler = () => {
  const [, makeRequest] = useImperativeRequestWrapper('shipmentV3');
  const addError = useError();

  return async (shipmentId: string) => {
    try {
      const data = await exportShipmentData({
        shipmentId,
        makeRequest,
      });

      const blob = new Blob([data], {
        type: 'application/zip',
      });

      saveAs(blob, `export_${shipmentId}.zip`);
    } catch (error) {
      addError(error);
    }
  };
};
